import React, { useEffect, useState } from "react";
import { Modal, Button, Form, InputGroup } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { API_ENDPOINTS } from "../../constant/_constant";
import usePostRequest from "../../hooks/usePostRequest";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

function ConfirmProductPopup({
  show,
  onClose,
  skuId,
  rfqId,
  vendorId,
  productName,
  onProductAdded,
  description,
  aspettoCost,
  customerPrice,
}) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const orderType = useSelector((state) => state.order.orderType);
  console.log("orderType", orderType);

  const { isLoading: createLoading, postData } = usePostRequest(
    API_ENDPOINTS.ADD_SKU,
  );

  const [formId, setFormId] = useState(null);

  const generateUniqueId = () => {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    let result = "";
    for (let i = 0; i < 8; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters.charAt(randomIndex);
    }

    const timestamp = Date.now().toString();
    const uniqueId = result + timestamp.slice(-4);
    return uniqueId;
  };

  useEffect(() => {
    const newFormId = generateUniqueId();
    setFormId(newFormId);
    // reset();
  }, []);

  useEffect(() => {
    let defaultType = "non-inventory";

    if (orderType === "CRK" || orderType === "S" || orderType === "M") {
      defaultType = "inventory";
    } else if (orderType === "DS") {
      defaultType = "non-inventory";
    }

    reset({
      productType: defaultType,
    });
  }, [orderType, reset]);

  const handleConfirm = (formData) => {
    const payload = {
      rfq_id: rfqId,
      vendor_id: vendorId,
      sku_id: skuId,
      name: productName,
      type: formData.productType,
      attachment_id: formId,
      aspetto_price: Number(aspettoCost),
      customer_price: Number(customerPrice),
      description: description || null,
      kit_type: null,
      description_sales: null,
      productKits: [],
    };

    const onSuccess = (response) => {
      if (onProductAdded) {
        onProductAdded(response);
      }
      reset();
      onClose();
    };

    const onError = (error) => {
      console.error("Failed to add SKU:", error);
      toast.error(error?.message);
    };

    postData(payload, onSuccess, onError);
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header
        className="justify-content-center d-block text-center"
        closeButton
      >
        <Modal.Title className="tittle_deal">Add Product</Modal.Title>
        <p className="mb-0">
          Please confirm if you want to add <strong>{skuId}</strong> as a new
          product.
        </p>
      </Modal.Header>

      <Form onSubmit={handleSubmit(handleConfirm)}>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label className="required">Product Type</Form.Label>
            <InputGroup>
              <Form.Select
                {...register("productType", {
                  required: "Product Type is required",
                })}
              >
                <option value="non-inventory">Non-Inventory</option>
                <option value="inventory">Inventory</option>
                <option value="kit">Kit</option>
              </Form.Select>
            </InputGroup>
            {errors.productType && (
              <span className="text-danger">{errors.productType.message}</span>
            )}
          </Form.Group>
        </Modal.Body>

        <Modal.Footer className="justify-content-center">
          <Button
            variant="secondary"
            onClick={onClose}
            disabled={createLoading}
          >
            Cancel
          </Button>
          <Button variant="warning" type="submit" disabled={createLoading}>
            {createLoading ? "Adding..." : "Confirm"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default ConfirmProductPopup;
